var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',[_vm._v(" "+_vm._s(_vm.$t("page_not_found.body"))+" ")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t("page_not_found.return")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }